import { combineReducers } from 'redux';

const reducer = combineReducers({
});

export type RootState = ReturnType<typeof reducer>;

export default reducer;
